/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getShopInfo = /* GraphQL */ `
  query GetShopInfo($id: Int!) {
    getShopInfo(id: $id) {
      id
      name
      address
      tel
      state
      dayOff
      products {
        id
        name
        nameEn
        price
        image
        hasOption
        hasSetOption
        categoryId
        description
        options
        setmenuOption
      }
      categoris {
        id
        name
      }
      options {
        id
        name
        description
        type
        isRequired
        selectionType
        hasLimit
        limit
        isGoods
        items {
          name
          price
        }
      }
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      name
      amount
      image
      shippingFee
      subTotal
      total
      type
      status
      paymentStatus
      destination {
        postal_code
        pref
        city
        town
        address1
        address2
      }
      customerId
      customer {
        id
        lineId
        name
        email
        phone
        destinationIndex
        address {
          postal_code
          pref
          city
          town
          address1
          address2
        }
        stripeCustomerId
        createdAt
        updatedAt
      }
      paymentIntentId
      createdAt
      updatedAt
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        amount
        image
        shippingFee
        subTotal
        total
        type
        status
        paymentStatus
        destination {
          postal_code
          pref
          city
          town
          address1
          address2
        }
        customerId
        customer {
          id
          lineId
          name
          email
          phone
          destinationIndex
          stripeCustomerId
          createdAt
          updatedAt
        }
        paymentIntentId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      lineId
      name
      email
      phone
      destinationIndex
      address {
        postal_code
        pref
        city
        town
        address1
        address2
      }
      stripeCustomerId
      createdAt
      updatedAt
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lineId
        name
        email
        phone
        destinationIndex
        address {
          postal_code
          pref
          city
          town
          address1
          address2
        }
        stripeCustomerId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerByLineId = /* GraphQL */ `
  query CustomerByLineId(
    $lineId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByLineId(
      lineId: $lineId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lineId
        name
        email
        phone
        destinationIndex
        address {
          postal_code
          pref
          city
          town
          address1
          address2
        }
        stripeCustomerId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
